import { render, staticRenderFns } from "./KeyMock.vue?vue&type=template&id=23bf537a&scoped=true&"
import script from "./KeyMock.vue?vue&type=script&lang=js&"
export * from "./KeyMock.vue?vue&type=script&lang=js&"
import style0 from "./KeyMock.vue?vue&type=style&index=0&id=23bf537a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bf537a",
  null
  
)

export default component.exports